import dayjs from "dayjs";
import { BaseStoredItem } from "./BaseStoredItem";

type DatesType = {
  startDate: string | Date;
  endDate: string | Date;
};

export class StoredDates extends BaseStoredItem<DatesType> {
  public async get() {
    const gottenDates = await this.retrieveData();
    if (gottenDates) {
      return this.validateDates(gottenDates);
    }
    return Promise.resolve(null);
  }

  storageKey() {
    return "dates";
  }

  validateDates(dates: DatesType) {
    const startDate = dates.startDate;
    const endDate = dates.endDate;

    // Check if the date got is valid and in the future
    if (
      dayjs(startDate).isValid() &&
      dayjs(startDate).isAfter(dayjs()) &&
      dayjs(endDate).isValid() &&
      dayjs(endDate).isAfter(dayjs())
    ) {
      return { startDate, endDate };
    }

    return null;
  }
}
